import { useQuery } from '@tanstack/react-query';
// Service
import { getBookingById, getBookings } from './bookingsService';

/**
 * @description Get the list of bookings.
 * @param {object} queryParams
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {total: number, page: number, data: Booking[]}, Error>}
 */
export const useGetBookingListQuery = (queryParams, options) => useQuery({
  queryKey: ['get-bookings', queryParams],
  queryFn: () => getBookings(queryParams),
  ...options,
});

/**
 * @description Get the one booking.
 * @param {string} id
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<Booking, Error>}
 */
export const useGetBookingQuery = (id, options) => useQuery({
  queryKey: ['get-booking', id],
  queryFn: () => getBookingById(id),
  ...options,
});
